(() => {
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-ff-almanac]')];
    if (scope.matches?.('[data-ff-almanac]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.almanacReady) return;
      root.dataset.almanacReady = 'true';
      const notes = [...root.querySelectorAll('[data-month-note]')];
      const select = root.querySelector('[data-month-select]');
      const pool = [...root.querySelectorAll('[data-omen]')];
      const button = root.querySelector('[data-turn-leaf]');
      const title = root.querySelector('[data-omen-title]');
      const text = root.querySelector('[data-omen-text]');
      let remaining = [], last = pool.length ? 0 : -1;
      function showMonth(id) {
        notes.forEach(note => { note.hidden = note.dataset.monthNote !== id; });
        select.value = id;
      }
      if (notes.length) {
        const current = notes.find(n => Number(n.dataset.month) === new Date().getMonth() + 1) || notes[0];
        showMonth(current.dataset.monthNote);
        root.querySelector('[data-month-controls]').hidden = false;
        select.addEventListener('change', () => showMonth(select.value));
      }
      function showLeaf(index) {
        title.textContent = pool[index].querySelector('[data-note-title]').textContent;
        text.textContent = pool[index].querySelector('[data-note-text]').textContent;
        last = index;
      }
      if (pool.length) {
        button.hidden = false;
        button.disabled = pool.length === 1;
        remaining = pool.map((_,i) => i).filter(i => i !== last);
        button.addEventListener('click', () => {
          if (!remaining.length) remaining = pool.map((_,i) => i).filter(i => i !== last);
          if (!remaining.length) return;
          const at = Math.floor(Math.random() * remaining.length);
          showLeaf(remaining.splice(at, 1)[0]);
        });
      }
      root.addEventListener('shopify:block:select', event => {
        const id = event.detail?.blockId;
        const monthly = notes.find(n => n.dataset.monthNote === id);
        if (monthly) showMonth(id);
        const leaf = pool.findIndex(n => n.getAttribute('data-shopify-editor-block')?.includes(id));
        if (leaf >= 0) showLeaf(leaf);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
